var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"public"}},[_c('Header',{attrs:{"title":_vm.appTitle}}),_c('transition',{attrs:{"name":"bounce","mode":"out-in"}},[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }